<template>
  <div class="legend">
    <LegendLoading v-if="this.legendFetching" />
    <NotFoundText v-if="!this.legendInfo?.length" />
    <div
      class="legend__empty"
      v-if="!this.legendFetching && !this.legendInfo?.length"
    >
      <q-btn
        size="sm"
        padding="xs"
        color="green"
        @click="() => reloadData && reloadData()"
      >
        Получить данные
        <q-icon name="replay" class="reloadIcon" />
      </q-btn>
    </div>
    <div v-if="!this.legendFetching" class="legend__items">
      <div
        class="legend__item"
        style="margin-bottom: 15px;"
        v-if="!!this.legendInfo?.length"
      >
        <q-btn
          size="sm"
          padding="xs"
          color="green"
          @click="() => reloadData && reloadData()"
        >
          <q-tooltip>Обновить</q-tooltip>
          <q-icon name="replay" class="reloadIcon" />
        </q-btn>
        <q-btn
          v-if="!!this.selectable"
          :icon="this.allBlocked ? 'lock' : 'lock_open'"
          size="sm"
          padding="xs"
          color="primary"
          @click="() => onBlock && onBlock(null, true)"
        >
          <q-tooltip
            >{{this.allBlocked ? 'Разблокировать' : 'Заблокировать'}}
            все</q-tooltip
          >
        </q-btn>
      </div>
      <div
        class="legend__item"
        v-for="(item, i) in this.legendInfo"
        :key="item.floor_param_type_id"
      >
        <div class="legend__item_content">
          <div
            class="legend__color"
            :style="{ backgroundColor: item.floor_param_type_color }"
          />
          <q-icon
            v-if="!!this.selectable"
            :name="item.is_blocked ? 'lock' : 'lock_open'"
            class="lockIcon"
            @click="() => onBlock && onBlock(item.floor_param_type_id)"
          >
            <q-tooltip
              >{{item.is_blocked ? 'Разблокировать' : 'Заблокировать'}}
            </q-tooltip></q-icon
          >
          <span
            :class="['legend__item_text', {legend__item_textSelectable: !!this.selectable}, {legend__item_textSelected: this.selectable && this.selected?.includes(item.floor_param_type_id) }]"
            @click="() => this.onSelect && this.onSelect(item.floor_param_type_id)"
            >{{ item.floor_param_type_name }} -
            <i>{{ item.param_value }} {{ item.unit_name || '' }}</i></span
          >
        </div>
      </div>
      <div
        v-if="this.legendInfo?.length"
        class="legend__item legend__item_count"
      >
        <span class="legend__item_text">Контрольная сумма:</span>
        <span>{{ paramValueCount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import LegendLoading from "./LegendLoading.vue";

export default {
  name: "Legend",
  components: {LegendLoading},
  props: ['legendInfo', 'legendFetching', 'selectable', 'onSelect', 'selected', 'onBlock', 'reloadData'],
  computed: {
    allBlocked() {
      return this.legendInfo?.every(item => item.is_blocked)
    },
    paramValueCount() {
      const count = this.legendInfo?.reduce((acc, item) => {
        if (item.param_value) {
          acc = (item.param_value || 0) + acc;
        }
        return acc;
      }, 0);
      if(count)
        return count.toFixed(2)
      return count
    }
  }
};
</script>

<style scoped lang="scss">

.legend {
  position: absolute;
  width: 300px;
  border: 1px solid #e5e5e5;
  top: 20px;
  right: 20px;
  padding: 10px 0;
  background-color: rgb(255, 255, 255);
  border-radius: 8px;

  &__items {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  &__empty {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}
.legend__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;

  &_content {
    display: flex;
    align-items: center;
    font-size: 13px;
    line-height: 1.25;
  }

  &_text {
    i {
      font-style: normal;
      font-weight: 400;
      color: #2c2c2c;
    }

    &Selectable {
      &:hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    &Selected {
      color: #1264d7;
      text-decoration: underline;
      i {
        color: #1264d7;
      }
    }
  }
  &_count {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    border-top: 1px solid #dfdfdf;
    padding-top: 5px;
    margin-top: 5px;
  }
}
.legend__color {
  width: 15px;
  height: 15px;
  border-radius: 5px;
  margin-right: 10px;
  flex-shrink: 0;
}
.lockIcon {
  margin-right: 5px;
  cursor: pointer;
  font-size: 16px;
}
</style>
